import ImageUploader from './ImageUploader'
import './ImageUploader.less'

export type {
  ImageUploadItem,
  ImageUploaderRef,
  ImageUploaderProps,
  UploadTask,
} from './iImageUploader'

export default ImageUploader
